import { UseLoadingReturn } from "@/hooks/use-loading";
import useUpdate from "@/hooks/use-update";
import { ICustomerSalesProductInput } from "@/interfaces/customer-sales-product.interfaces";
import {
  CustomerSalesProduct,
  customerSalesProductService,
} from "@/services/customer-sales-product.service";
import { UpdateByIdProps } from "@/types/requests.types";

export type UpdateCustomerSalesProductProps = UpdateByIdProps<ICustomerSalesProductInput>;

export type UseUpdateCustomerSalesProductReturn = {
  update: (props: UpdateCustomerSalesProductProps) => Promise<void>;
} & UseLoadingReturn;

const useUpdateCustomerSalesProduct = (): UseUpdateCustomerSalesProductReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, update } =
    useUpdate<ICustomerSalesProductInput>({
      operation: (formData, productId) =>
        customerSalesProductService.update(
          productId,
          formData as unknown as Partial<CustomerSalesProduct>
        ),
    });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    update,
  };
};

export default useUpdateCustomerSalesProduct;
